import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { C } from "../styles";
import { RAD } from "../ui";

const NAV_ITEMS = [
  { id: "home",      label: "Home",         hint: "Overview" },
  { id: "upload",    label: "Sessions",     hint: "Create & manage" },
  { id: "batch",     label: "Batch Upload", hint: "Bulk ingest" },
  { id: "dashboard", label: "Dashboard",    hint: "Track progress" },
];

function Sidebar({ user, userName, pid, currentPage, onNavigate, theme = "dark", onToggleTheme, showOutdoor = false }) {
  const initial = (userName || user.email)[0].toUpperCase();
  const navItems = showOutdoor
    ? [...NAV_ITEMS, { id: "outdoor", label: "Outdoor Guide", hint: "Locations & clips" }]
    : NAV_ITEMS;

  return (
    <div className="sidebar" style={{
      width: "248px",
      minHeight: "100vh",
      background: C.sidebar,
      borderRight: `1px solid ${C.border}`,
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      left: 0,
      top: 0,
      zIndex: 10,
    }}>
      {/* Brand lockup — theme-adaptive: a blue gradient dot + wordmark.
          Replaces the old logo.png which baked in a "BLUE DOT" text mark
          (causing it to read twice next to the wordmark) and didn't adapt
          to light mode. */}
      <div style={{ padding: "26px 22px 28px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
          <img
            src="/logo.png"
            alt=""
            style={{
              width: "38px",
              height: "38px",
              objectFit: "contain",
              flexShrink: 0,
            }}
          />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: "16px", fontWeight: "800", color: C.text1, letterSpacing: "-0.02em", lineHeight: 1.15 }}>
              Second Orbit
            </div>
            <div style={{ fontSize: "12px", color: C.text3, letterSpacing: "0.02em", marginTop: "3px" }}>
              Contributor Portal
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div style={{ height: "1px", background: C.borderSubtle, margin: "0 16px 16px" }} />

      {/* Nav */}
      <nav style={{ flex: 1, padding: "0 10px" }}>
        {navItems.map((item) => {
          const isActive = currentPage === item.id;
          return (
            <button
              key={item.id}
              className="nav-btn"
              onClick={() => onNavigate(item.id)}
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "10px 14px 10px 18px",
                marginBottom: "2px",
                background: isActive ? C.primarySoft : "transparent",
                border: "none",
                borderRadius: RAD.md,
                color: isActive ? C.text1 : C.text2,
                cursor: "pointer",
                textAlign: "left",
              }}
            >
              {/* Active indicator strip */}
              {isActive && (
                <span style={{
                  position: "absolute",
                  left: "4px",
                  top: "22%",
                  bottom: "22%",
                  width: "3px",
                  background: C.primary,
                  borderRadius: "3px",
                }} />
              )}
              <span style={{
                fontSize: "14px",
                fontWeight: isActive ? "600" : "500",
                letterSpacing: "-0.01em",
                color: isActive ? C.text1 : C.text2,
              }}>
                {item.label}
              </span>
              <span style={{
                fontSize: "12px",
                color: isActive ? C.primary : C.text3,
                marginTop: "2px",
              }}>
                {item.hint}
              </span>
            </button>
          );
        })}
      </nav>

      {/* User section */}
      <div style={{ padding: "16px 14px 20px", borderTop: `1px solid ${C.border}` }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px", padding: "0 4px" }}>
          <div style={{
            width: "34px",
            height: "34px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: "700",
            color: "#fff",
            flexShrink: 0,
          }}>
            {initial}
          </div>
          <div style={{ overflow: "hidden", flex: 1 }}>
            <div style={{
              fontSize: "14px",
              fontWeight: "600",
              color: C.text1,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
              {userName}
            </div>
            <div style={{ fontSize: "12px", color: C.primary, fontWeight: "500", marginTop: "2px" }}>
              PID: {pid}
            </div>
          </div>
        </div>

        {/* Theme toggle */}
        {onToggleTheme && (
          <button
            onClick={onToggleTheme}
            className="theme-toggle"
            style={{ marginBottom: "10px" }}
            title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
          >
            <span style={{ fontSize: "14px", lineHeight: 1 }}>{theme === "dark" ? "☀️" : "🌙"}</span>
            <span>{theme === "dark" ? "Light mode" : "Dark mode"}</span>
          </button>
        )}

        <button
          onClick={() => signOut(auth)}
          style={{
            width: "100%",
            padding: "8px",
            background: "transparent",
            border: `1px solid ${C.border}`,
            borderRadius: RAD.sm,
            color: C.text3,
            fontSize: "13px",
            cursor: "pointer",
            transition: "all 0.15s ease",
            fontFamily: "inherit",
          }}
          onMouseEnter={(e) => { e.currentTarget.style.borderColor = "var(--border-2)"; e.currentTarget.style.color = "var(--text-2)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.color = "var(--text-3)"; }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
